import {Skeleton} from '@chekinapp/ui';

export const PaymentFormSkeleton = () => {
  return (
    <div className="flex flex-col w-full space-y-3">
      <Skeleton className="h-[16px] rounded-xl" />
      <Skeleton className="h-[50px] rounded-xl" />
      <Skeleton className="h-[16px] rounded-xl" />
      <Skeleton className="h-[50px] rounded-xl" />
      <Skeleton className="h-[64px] rounded-xl" />
    </div>
  );
};
